import { useCCTM, useModel } from "@bcm-dev/bcms-vite";

export default function Nav(id) {
    // Converts an XML string into an XML DOM object
    function stringToXML(xmlString) {
        const parser = new DOMParser();
        return parser.parseFromString(xmlString, "application/xml");
    }

    // Converts an XML DOM object into a string
    function XMLToString(xmlString) {
        const serializer = new XMLSerializer();
        return serializer.serializeToString(xmlString);
    }

    const { user, branding, demos } = useModel();
    const bid = branding.options.bid_abi22;
    const xml = useCCTM();
    
    // Convert XML data into strings
    let abiXML = XMLToString(xml);
    let mabiXML = window.mabiMenu ? XMLToString(window.mabiMenu) : XMLToString(xml);

    // Convert the XML strings into XML DOM objects
    let abiNav = stringToXML(abiXML);
    let abiSideNav = abiNav.querySelector(`[id="sideNav"]`);
    let mabiSideNav = stringToXML(mabiXML).querySelector(`[id="sideNav"]`);

    // Check if the ID is 'sideNav', and apply the logic accordingly
    if (id === "sideNav") {
        // Recursively applies the callback function to each element in the XML structure
        function mapXMLElements(node, callback, finalCallback) {
            // Apply the callback to the current node, except for the node with id "sideNav"
            if (node.id !== "sideNav") {
                callback(node);
            }

            // Recursively traverse child nodes
            node.childNodes.forEach((childNode) => {
                if (childNode.nodeType === 1) { // Ensure it's an ELEMENT_NODE
                    mapXMLElements(childNode, callback, finalCallback);
                }
            });

            // Execute the final callback after traversal
            if (node.parentNode === null && typeof finalCallback === "function") {
                finalCallback();
            }
        }

        // Removes a node from its parent if it exists
        function removeNode(node) {
            try {
                if (node && node.parentNode) {
                    node.parentNode.removeChild(node); // Remove the node from its parent
                } else {
                    console.warn(`Node with ID '${node.id}' not found.`); // If node not found, log a warning
                }
            } catch (e) {
                // Handle errors if any
            }
        }

        // Replaces the sideNav node with a new one
        function replaceNode(newNode) {
            try {
                // Replace the target node with the new node
                abiNav.querySelector(`[id="sideNav"]`).parentNode.replaceChild(
                    abiNav.importNode(newNode, true),
                    abiNav.querySelector(`[id="sideNav"]`)
                );
            } catch (e) {
                // Handle errors if any
                console.log(e);
            }
        }

        // Checks if a node exists in the new sideNav, and removes it if it doesn't
        const check = (node) => {
            if (node.id && node.id !== "") {
                if (!abiSideNav.querySelector(`[id="${node.id}"]`)) {
                    removeNode(node); // Remove the node if it doesn't exist in the new sideNav
                }
            }
        };

        // Final check and replace the sideNav with the new sideNav
        const finalCheck = () => {
            return replaceNode(mabiSideNav);
        };

        try {
            // Map through elements of mabiSideNav, perform checks and replace nodes
            mapXMLElements(mabiSideNav, check, finalCheck);
        } catch (e) {
            // Handle errors during mapping
        }
    }

    // useEffect hook to trigger sideNav updates based on changes in abiNav
   

    return abiNav; // Return the modified abiNav (sideNav)
}
